document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-burger]');
  if (b) { document.querySelector('.nav').classList.toggle('is-open'); }

  var t = e.target.closest('[data-thumb]');
  if (t) {
    var main = document.getElementById('PdpMain');
    if (main) { main.src = t.dataset.full; main.srcset = ''; }
    document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
    t.classList.add('is-active');
  }

  var q = e.target.closest('[data-qty]');
  if (q) {
    var input = q.parentNode.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v += (q.dataset.qty === 'up' ? 1 : -1);
    input.value = v < 1 ? 1 : v;
  }
});

document.addEventListener('change', function (e) {
  if (e.target.matches('[data-sort]')) {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', e.target.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  }
  if (e.target.matches('[data-variant-select]')) {
    var form = e.target.closest('form');
    if (form) { form.querySelector('[name="id"]').value = e.target.value; }
  }
});
